import { mediaQueries, palette } from '@centivo/react-components'
import styled, { css } from 'styled-components'

import { ContentSection } from 'src/refactor/structure'

interface Props {
  shouldHideMap?: boolean
  isListEmpty?: boolean
  isRequestCanceled?: boolean
}

interface ResultsListFooterProps {
  isSliceTemplate: boolean
}

export const LoadingContainer = styled.div`
  width: 100%;
  height: 78px;
  display: flex;
  flex-direction: column;
  align-items: center;

  > span {
    margin-top: 20px;
    font-size: 1.25rem;
    font-weight: 700;
    color: ${palette.brand.orange};
    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return {
            fontWeight: 500,
          }
        default:
          return {}
      }
    }}
  }
`

export const LoadingMessage = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: row;
  gap: 8px;

  > button {
    background: transparent;
    border: none;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    color: ${palette.brand.orange};

    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return {
            fontWeight: 500,
          }
        default:
          return {}
      }
    }}
  }
`

export const RlListMapContainer = styled(ContentSection)<Props>`
  display: grid;
  grid-template-columns: 100%;
  grid-column-gap: 1.625rem;
  padding-bottom: 10rem !important;
  margin-bottom: 58px;

  @media ${mediaQueries.desktop} {
    grid-template-columns: ${props =>
      props.isListEmpty && !props.isRequestCanceled ? '1fr' : '57.5% 1fr'};
  }

  @media ${mediaQueries.mobile} {
    padding-bottom: 0;
  }
`

export const RlListContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const RlMapContainer = styled.div`
  > div {
    border-radius: 1.25rem;
  }
  @media ${mediaQueries.desktop} {
    display: flex;
    flex-direction: column;
    grid-column: 2;
    width: 100%;
    height: 100%;
  }
`

export const Disclaimer = styled.div`
  color: #212121;
  font-family: 'AnekGujarati';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: 0.28px;
  margin-bottom: 38px;
  margin-top: 43px;
  width: 28.125rem;
`

export const ResultsListFooter = styled.div<ResultsListFooterProps>`
  height: ${props => (props.isSliceTemplate ? '13rem' : '9rem')};
  width: 100vw;
  bottom: 0;
  left: 0;

  @media ${mediaQueries.ipadPro} {
    height: ${props => (props.isSliceTemplate ? '13rem' : '10rem')};
  }

  @media ${mediaQueries.tablet} {
    height: ${props => (props.isSliceTemplate ? '13rem' : '10rem')};
  }

  > div {
    width: 100%;
    padding: 0 1.25rem;
    margin: auto;

    ${({ theme }) => theme.screenWidth}
  }

  position: absolute;
  padding-top: 2.5rem;
  background-color: #f7f4e6;

  > div {
    @media ${mediaQueries.desktop} {
      padding: 0 2rem;
    }
  }

  li {
    border-radius: 6px !important;
  }
`

export const RlPaginateContainer = styled.div`
  width: 100%;
  user-select: none;

  background-color: #f7f4e6;

  * {
    color: #212121;
  }

  .disabled {
    color: #bbbdbf;
  }

  li:not(.next, .previous):hover,
  .active {
    background-color: ${palette.brand.darkGreen} !important;
  }

  li.next,
  li.previous {
    &::before {
      background-color: ${palette.brand.darkGreen};
    }
  }

  ul {
    min-width: auto;
  }

  @media ${mediaQueries.desktop} {
    margin-left: 4.6rem;
    max-width: 18.75rem;
    width: min-content;
  }
`
